import { useContext } from "react"

import { WSDispatchContext, WSDispatchType, WSStateContext, WSStateType } from "./WSContext.context"

export const useWSStateContext = (): WSStateType => {
    const context = useContext(WSStateContext)
    if (context === undefined) {
        throw new Error("useWSStateContext must be used within an WSContextProvider")
    }
    return context
}

export const useWSDispatchContext = (): WSDispatchType => {
    const context = useContext(WSDispatchContext)
    if (context === undefined) {
        throw new Error("useWSDispatchContext must be used within an WSContextProvider")
    }
    return context
}

export const useWSContext = (): [WSStateType, WSDispatchType] => {
    return [useWSStateContext(), useWSDispatchContext()]
}

export const useWebSocketProgress = (id: string) => {
    const { webSockets } = useWSStateContext()
    const webSocketEntry = webSockets[id]

    return {
        isRunning: Boolean(webSocketEntry),
        progress: webSocketEntry?.progress ?? 0,
        status: webSocketEntry?.status,
    }
}
